import './assets/main.css'
import { i18n } from '@/i18n'

import { createSSRApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createVuesticEssential } from 'vuestic-ui'

import App from './App.vue'
import VueGtag from 'vue-gtag'
import { createAppRouter } from './router'
import vuesticConfig from '../vuestic.config'
import Config from '@/utils/config'

export const createApp = (request?: any) => {
  /**
   * use createSSRApp to render the Vue App on the server
   * and send it to the user to do the hydration process
   */
  const app = createSSRApp(App)

  const router = createAppRouter()
  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)
  app.use(pinia)
  app.use(router)
  app.use(createVuesticEssential({
    config: vuesticConfig,
  }))
  const acceptLanguage = request?.headers['accept-language']
  const languageCookie = request?.cookies?.language
  app.use(i18n(request?.originalUrl, languageCookie, acceptLanguage), {})

  if (Config.googleAnalyticsTag) {
    app.use(VueGtag, {
      config: { id: Config.googleAnalyticsTag },
    })
  }

  return {
    app,
    router,
  }
}
